// 导入axios实例
import httpRequest from '@/utils/fetch'

// 登录
export function login (param) {
  return httpRequest({
    url: '/admin/login/login.json',
    method: 'post',
    data: param
  })
}

// 登录
export function logout (param) {
  return httpRequest({
    url: '/admin/login/logout.json',
    method: 'post',
    data: param
  })
}
